import * as React from 'react';
import { connect } from 'react-redux';
import * as _ from 'underscore';

import { AngularDirective } from '../common/react/components/AngularDirective';
import { ReactDirectiveProps } from '../ts/directives/reactDirectiveFactory';
import { BrowserTitleService } from '../ts/services/BrowserTitleService';
import { ServiceLocator } from './ServiceLocator';
import { AppState } from './state/AppState';
import { RootAdminUiState } from './state/RootAdminUIState';
import { MapStateToProps } from './utils/ConnectUtils';

export interface RootAdminUiStateProps {
  readonly rootAdminUiState: RootAdminUiState;
}

export interface RootAdminUiOwnProps extends ReactDirectiveProps {}

export type RootAdminUiProps = RootAdminUiOwnProps & RootAdminUiStateProps;

/*
  This displays the non-default RootAdminUiStates.
  It will render null for the default state.
  tbApp.ts will handle displaying a ui-view for the default case.
*/
export class RootAdminUi extends React.Component<RootAdminUiProps> {
  private unmounted: boolean = false;
  public render() {
    if (this.props.rootAdminUiState === 'default') {
      return null;
    }

    return (
      <div className="tb-column-flex-parent tb-fill">
        <div className="tb-flex-fill">
          {this.stateUi()}
        </div>
      </div>
    );
  }

  public componentDidMount() {
    // Reset the title to just the server name.
    // fatal means we were unable to load messages so don't try to set a title
    if (this.props.rootAdminUiState !== 'fatal' && this.props.rootAdminUiState !== 'bootstrap') {
      ServiceLocator.get<BrowserTitleService>('BrowserTitleService').setTitleToServerName();
    }
  }

  public componentWillUnmount() {
    this.unmounted = true;
  }

  private stateUi = () => {
    if (this.props.rootAdminUiState === 'untrusted') {
      return <AngularDirective
        angularContext={this.props.angularContext}
        template={`<div ng-include="'untrusted.html'"></div>`}
      />;

    } else if (this.props.rootAdminUiState === 'init') {
      return <AngularDirective
        angularContext={this.props.angularContext}
        template={`<tb:initialization></initialization>`}
      />;

    } else if (this.props.rootAdminUiState === 'interstitial') {
      return <AngularDirective
        angularContext={this.props.angularContext}
        template={'<tb:signing-in></tb:signing-in>'}
      />;

    } else if (this.props.rootAdminUiState === 'fatal') {
      return <span style={{marginLeft:20}}><h2>{'Fatal Error'}</h2></span>;
    }
  }
}

const mapStateToProps: MapStateToProps<RootAdminUiStateProps> = (state: AppState) => ({
  rootAdminUiState: state.rootAdminUiState,
});

export const ConnectedRootAdminUi: React.ComponentClass<RootAdminUiOwnProps> =
  connect(mapStateToProps)(RootAdminUi);
